import React from 'react';
import { X, Check } from 'lucide-react';
export function BeforeAfterSection() {
  return <section className="py-16 md:py-24 bg-white px-5 border-b border-gray-100" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <h2 className="text-3xl md:text-5xl font-bold text-center text-gray-900 mb-12 md:mb-16 tracking-tight" data-id="element-3">
          Tu vida antes y después del Manual
        </h2>

        <div className="space-y-6 md:space-y-0 md:grid md:grid-cols-2 md:gap-8 items-stretch" data-id="element-4">
          {/* Before Column */}
          <div className="bg-white rounded-2xl p-6 md:p-10 border border-rose-100 flex flex-col" data-id="element-5">
            <div className="flex items-center gap-4 mb-6" data-id="element-6">
              <div className="bg-rose-50 text-rose-500 p-3 rounded-xl border border-rose-100" data-id="element-7">
                <X className="w-6 h-6" strokeWidth={3} data-id="element-8" />
              </div>
              <h3 className="text-2xl font-bold text-rose-900" data-id="element-9">Antes</h3>
            </div>

            <ul className="space-y-3 flex-1" data-id="element-10">
              {['Sofocos y mal humor constante', 'Inflamación y pesadez diaria', 'Niebla mental y olvidos', 'Comer sin saber qué te conviene', 'Resignación ante los síntomas'].map((item, i) => <li key={i} className="flex items-center gap-3 text-rose-900/80 font-medium text-base p-3 rounded-xl border border-rose-50" data-id="element-11">
                  <span className="w-2 h-2 bg-rose-400 rounded-full shrink-0" data-id="element-12"></span>
                  {item}
                </li>)}
            </ul>
          </div>

          {/* After Column */}
          <div className="bg-white rounded-2xl p-6 md:p-10 border-2 border-emerald-200 flex flex-col relative shadow-md" data-id="element-13">
            <div className="flex items-center gap-4 mb-6" data-id="element-14">
              <div className="bg-emerald-600 text-white p-3 rounded-xl shadow-sm" data-id="element-15">
                <Check className="w-6 h-6" strokeWidth={3} data-id="element-16" />
              </div>
              <h3 className="text-2xl font-bold text-emerald-900" data-id="element-17">Después</h3>
            </div>

            <ul className="space-y-3 flex-1" data-id="element-18">
              {['Hormonas más equilibradas', 'Menos hinchazón y más ligereza', 'Claridad, enfoque y buen humor', 'Comidas diseñadas para tu etapa', 'Vitalidad real y descanso profundo'].map((item, i) => <li key={i} className="flex items-center gap-3 text-emerald-900 font-bold text-base p-3 rounded-xl bg-emerald-50 border border-emerald-100" data-id="element-19">
                  <div className="bg-emerald-200 p-0.5 rounded-full shrink-0" data-id="element-20">
                    <Check className="w-3.5 h-3.5 text-emerald-700" strokeWidth={3} data-id="element-21" />
                  </div>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}